import {http} from '../../plugins/http';

export default {
    indexOnSite() {
        return http.get(`/api/v1/notification/service-level-agreement-reminder/on-site`);
    }
};



// WEBPACK FOOTER //
// ./src/services/Notification/SlaReminderController.js